<!--实现全国地图下钻，由于涉及JSON文件较多，所以就直接引用在线JSON https://geo.datav.aliyun.com/areas_v3/bound/-->
<template>
    <div>
        <div class="box">
            <div class="echarts" ref="areaRankingAll" @dblclick="goback">
            </div>
            <div class="check">
                <div class="cityName"> {{ QCity.length ? QCity[QCity.length - 1] : '中华人民共和国' }} </div>
                <!-- <el-cascader @change="cityChange" v-model="QCity" :options="city"
                    :props="{ checkStrictly: true, value: 'label', label: 'label' }" placeholder="请选择区域"
                    clearable></el-cascader> -->
                <div class="item">
                    <p>截止： {{ getDate() }} </p>
                </div>
                <div class="item" v-if="QCity.length < 1">
                    <p>已覆盖省级行政区数：</p><span>{{ cityInfo[1] }}</span>
                </div>
                <div class="item" v-if="QCity.length < 2">
                    <p>已覆盖地级行政区数：</p><span>{{ cityInfo[2] }}</span>
                </div>
                <div class="item" v-if="QCity.length < 3">
                    <p>已覆盖县级行政区数：</p><span>{{ cityInfo[3] }}</span>
                </div>
                <div class="item">
                    <p>已覆盖景区/景点数：</p><span>{{ cityInfo[4] }}</span>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import city from '@/utils/chinaCity'
import axios from 'axios'//采用axios动态请求数据
var echarts = require('echarts')
export default {
    name: "areaRankingAll",
    mounted() {
        this.initChart();//初始化地图

    },

    data() {
        return {
            QCity: [],
            cityInfo: {},
            regions: {},
            city: city,
            myChart: null,
            //线上请求JSON文件数据地址
            publicUrl: "/homeReception/mapCode/",
            //allCode 区域行政编码信息
            allCode: [
                // {name:"廉江市",adcode:"440881"}
            ],
        }
    },
    created() {
        this.getRegionalNumber({ region: '' })
    },
    methods: {
        // 双击返回中国地图
        goback() {
            this.getRegionalNumber({ region: '' })
            this.initChart()
        },

        async getGeoJson(jsonName) {
            let aa = await axios.get(this.publicUrl + jsonName)
            console.log(aa);
            return aa
        },
        initEcharts(geoJson, name, chart) {
            let self = this;
            // this.myChart = echarts.init(this.$refs.areaRankingAll);
            echarts.registerMap(name, geoJson);
            let option = {
                layoutCenter: ['50%', '50%'],//位置
                layoutSize: '90%',//大小
                left: 'center',
                top: 'center',
                title: {
                    show: false,
                    x: 'center',
                    y: 20,
                    text: name,
                },

                tooltip: {
                    trigger: 'item',
                    formatter(params) {
                        return `${params.name}</br>数量：${self.lookNumber(params.name)}`;
                    },
                    backgroundColor: "transparent",
                },


                geo: [{
                    map: name,
                    label: {
                        show: false
                    },
                    select: {
                        itemStyle: {
                            // 设置地图点击后的颜色
                            areaColor: '#dc383b',
                            borderWidth: 1,
                            borderColor: '#dc383b',
                        }
                    },

                    itemStyle: {
                        normal: {
                            areaColor: '#fff',
                            borderWidth: 1,
                            borderColor: '#ccc',
                        },


                    },
                    emphasis: {
                        focus: 'none',
                        itemStyle: {
                            areaColor: '#dc383b',
                            borderWidth: 1,
                            borderColor: '#dc383b',
                        },
                    },
                    zlevel: 1,
                },
                {
                    map: name,
                    itemStyle: {
                        normal: {
                            //此处border设置你想要显示的地图外边框样式，可设置border颜色，阴影等
                            borderColor: '#dc383b',
                            borderWidth: 3
                        },
                    },
                }
                ],

                series: [{
                    type: 'map',
                    map: name,
                    geoIndex: 0,
                    data: [],

                }]
            }
            chart.setOption(option);
            chart.off("click");
            chart.on('click', async (params) => {
                //点击区域时的行政编码，然后再进行匹配
                let clickCode = self.allCode.filter(areaJson => areaJson.name === params.name)[0].adcode;
                //1、如果要实现多级下钻并且展示子区域的话，下钻点击事件请求的JSON必须是该点击区域的全面父级JSON(即没有自己只有孩子们组成)
                //2、如果要实现地图只下钻一次，并且不展示目标下钻区域的子区域。如第一层地图是中国，实现点击某个省下钻到该省，但是不展示该省的子区域，那么下钻点击事件请求的JSON必须是该点击区域的确切json(即只有自己没有孩子们)
                //声明：比如这里线上引用的父级JSON带有：地域行政编码_full.json(如中国 100000_full.json),子级JSON是行政编码.json(如廉江市 440881.json)
                const res = await self.getGeoJson(clickCode + '_full.json')
                try {
                    //这里处理省市
                    self.initEcharts(res, params.name, chart)

                } catch (err) {
                    //这里处理县区
                    self.$message.info('这是最后一级，双击空白区域返回中国地图')
                    console.log(err);
                }

                // // 如果到县级就替换最后一项（县）不然会重复叠加
                if (self.QCity.length == 3) {
                    self.QCity.splice(self.QCity.length - 1, 1)
                }
                // console.log(params.name);
                // console.log(self.QCity);
                self.QCity.push(params.name)
                let ppp = {
                    region: self.QCity.length ? self.QCity.join('/') : '',
                    regionLevel: self.QCity.length + 1
                }

                self.getRegionalNumber(ppp)
            })
            //  当窗口或者大小发生改变时执行resize，重新绘制图表
            window.addEventListener("resize", function () {
                chart.resize();
            });

        },

        // 请求数量
        async getRegionalNumber(params) {
            // console.log(params);
            const res = await axios.get('/homeReception/regionalStatistics', { params: params })
            this.cityInfo = res.data
            // console.log(this.QCity.length);
            this.regions = res.data.regions
            // if (this.QCity.length >= 3) {
            //     console.log(111);
            //     this.regions = this.regions
            // } else {
            //     console.log(222);
            //     this.regions = res.data.regions
            // }

            // console.log(this.regions);
        },

        //带头函数-初始化
        initChart() {
            this.QCity = []
            let chart = echarts.init(this.$refs.areaRankingAll);
            //this.allCode获取所有的区域编码信息
            this.getGeoJson('all.json').then(all => {
                this.allCode = all;
            });
            //初始化地图展示
            this.getGeoJson('100000_full.json').then(China => {
                this.initEcharts(China, '中华人民共和国', chart);
            });
        },

        //查找对应的数量
        lookNumber(name) {

            let n = 0
            for (var key in this.regions) {
                // console.log(key, this.cityInfo.regions[key])
                if (key == name) {
                    // console.log(key, name, this.cityInfo.regions[key]);
                    n = this.regions[key]
                }
            }
            // n = `${this.cityInfo.regions}.${name}`
            return n
        },

        getDate() {
            const date = new Date(); //转换成Data();
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            return y + '年' + m + '月' + d + '日';

        }
    }
}
</script>

<style lang="scss" scoped>
.box {
    width: 100%;
    height: 920px;
    margin: 30px auto;
    display: flex;
    justify-content: space-between;

    .echarts {
        box-sizing: border-box;
        border: 1px solid #E8E8E8;
        width: 1240px;
        height: 100%;
    }

    .check {
        width: 340px;
        height: 100%;
        background: #F7F8FA;
        padding: 35px 0 0 35px;

        .cityName {
            font-weight: bold;
            font-size: 25px;
            margin-bottom: 10px;
        }

        .item {
            font-size: 16px;
            color: #717171;
            margin-top: 55px;
            display: flex;
            align-items: center;

            span {
                margin-left: 10px;
                font-size: 32px;
                font-weight: bold;
                color: #000000;
            }
        }
    }
}


/deep/ .el-cascader {
    width: 268px;
    height: 50px;

}

/deep/ .el-cascader .el-input {
    width: 260px;
    height: 50px;
}

/deep/ .el-cascader .el-input .el-input__inner {
    width: 100%;
    height: 100%;
    background: #F2F2F2;
}
</style>




// WEBPACK FOOTER //
// src/components/chinaMap.vue